import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { PricingPageComponent } from './pricing-page.component';

const routes = [
    {
        path     : 'pricing',
        component: PricingPageComponent
    }
];

@NgModule({
    declarations: [
      PricingPageComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ]
})

export class PricingPageModule
{

}
